






















import Vue from 'vue';
import VueCompositionAPI, {defineComponent} from '@vue/composition-api';
import {useMainFlight} from './useMainFlightDetails';

Vue.use(VueCompositionAPI);

const AmxStaticFlightDetailsCard = defineComponent({
  setup() {
    return useMainFlight();
  },
});

export default AmxStaticFlightDetailsCard;
